"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentStatus = void 0;
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["DRAFT"] = "draft";
    DocumentStatus["PENDING_VALIDATION"] = "pending_validation";
    DocumentStatus["VALIDATED"] = "validated";
    DocumentStatus["DIFFUSED"] = "diffused";
    DocumentStatus["REJECTED"] = "rejected";
    DocumentStatus["ARCHIVED"] = "archived";
})(DocumentStatus || (exports.DocumentStatus = DocumentStatus = {}));
//# sourceMappingURL=documentStatus.enum.js.map